import { IFrame } from '@e2m-customer-portal/ui';
import { ReactElement } from 'react';
import { useParams } from 'react-router';

export function ServiceCenter(): ReactElement {
  const { path, subpath } = useParams<{ path?: string; subpath?: string }>();
  let src = 'https://customerportal2.e2m.energy/';
  if (path) {
    if (subpath) {
      src += `${path}/${subpath}.html`;
    } else {
      src += `${path}.html`;
    }
  }

  return (
    <IFrame
      frameBorder={0}
      id="PH_MainContent_InfoseiteFrame"
      marginHeight={0}
      marginWidth={0}
      src={src}
      width="100%"
      /*
        You can use the sandbox attribute, which will ensure the content within
        the Iframe cannot change the parent(Host) web URL, access browser storage,
        cookies, or run plugins. If you add sandbox without any value document will
        be fully sandboxed.

        https://html.spec.whatwg.org/multipage/iframe-embed-object.html#attr-iframe-sandbox
      */
      sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
    />
  );
}
